export const isAuthenticated = () => (
  window.PlatformSDK.isLoggedIn() && window.PlatformSDK.loginProvider === "ciscosso"
);
